// extracted by mini-css-extract-plugin
export default {"maps":"index__maps--g7Crp"};